export interface GoldWingProps {
  size?: number;
  className?: string;
}

/**
 * Ala/pluma dorada estilizada. Va PEGADA a la última letra de "AZRAHEL" en el
 * bloque de cierre, no separada: en el mockup forma parte del logotipo de su
 * nombre. Decorativa — el nombre lo lleva el texto.
 */
export function GoldWing({ size = 34, className }: GoldWingProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 40 28"
      width={size}
      height={(size * 28) / 40}
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
      aria-hidden="true"
      focusable="false"
    >
      {/* Eje central y penacho */}
      <path d="M20 3.2 20 25" />
      <path d="M20 3.2c-1.5 1.9-2.3 4-2.4 6.4M20 3.2c1.5 1.9 2.3 4 2.4 6.4" />
      {/* Ala izquierda: tres plumas descendentes */}
      <path d="M18.6 9.4C14.4 9.1 9 10.4 4.2 13.4c4 .3 6.6.1 9.1-.9" />
      <path d="M18.6 14.2C14.2 14.2 9.2 15.6 5.2 18.4c3.7.3 6.1 0 8.4-1" />
      <path d="M18.6 18.8c-3.4.3-6.9 1.6-9.9 3.8 2.9.2 4.9-.1 6.8-1" />
      {/* Ala derecha, en espejo */}
      <path d="M21.4 9.4c4.2-.3 9.6 1 14.4 4-4 .3-6.6.1-9.1-.9" />
      <path d="M21.4 14.2c4.4 0 9.4 1.4 13.4 4.2-3.7.3-6.1 0-8.4-1" />
      <path d="M21.4 18.8c3.4.3 6.9 1.6 9.9 3.8-2.9.2-4.9-.1-6.8-1" />
    </svg>
  );
}
